(function () {
  "use strict";

  var SECTION_SELECTOR = "[data-wbr-section]";
  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initReviewsSection(section) {
    if (!section || section.__wbReviewsInit) return;

    var track = section.querySelector("[data-wbr-track]");
    var cards = Array.prototype.slice.call(section.querySelectorAll("[data-wbr-card]"));
    var dots = Array.prototype.slice.call(section.querySelectorAll("[data-wbr-dot]"));
    var prevBtn = section.querySelector("[data-wbr-prev]");
    var nextBtn = section.querySelector("[data-wbr-next]");
    var autoplay = section.dataset.autoplay === "true" && !prefersReduced;
    var interval = parseInt(section.dataset.interval, 10) * 1000 || 4000;

    if (!track || !cards.length) return;

    section.__wbReviewsInit = true;

    var currentIndex = 0;
    var timer = null;
    var scrollRaf = null;
    var resizeTimer = null;

    function clampIndex(index) {
      if (index < 0) return cards.length - 1;
      if (index >= cards.length) return 0;
      return index;
    }

    function updateDots() {
      dots.forEach(function (dot) {
        dot.classList.remove("is-active");
      });

      if (dots[currentIndex]) {
        dots[currentIndex].classList.add("is-active");
      }
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= maxScroll - 4;

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    function findClosestIndex() {
      var trackLeft = track.getBoundingClientRect().left;
      var closest = 0;
      var minDist = Infinity;

      cards.forEach(function (card, index) {
        var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (dist < minDist) {
          minDist = dist;
          closest = index;
        }
      });

      return closest;
    }

    function goTo(index) {
      currentIndex = clampIndex(index);

      var card = cards[currentIndex];
      if (!card) return;

      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? "auto" : "smooth"
      });

      updateDots();

      window.setTimeout(updateArrows, prefersReduced ? 0 : 260);
    }

    function startTimer() {
      if (!autoplay || cards.length <= 1) return;

      clearInterval(timer);
      timer = setInterval(function () {
        goTo(currentIndex + 1);
      }, interval);
    }

    function stopTimer() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function resetTimer() {
      stopTimer();
      startTimer();
    }

    function onScroll() {
      if (scrollRaf) return;

      scrollRaf = requestAnimationFrame(function () {
        var closest = findClosestIndex();

        if (closest !== currentIndex) {
          currentIndex = closest;
          updateDots();
        }

        updateArrows();
        scrollRaf = null;
      });
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateArrows();
        goTo(currentIndex);
      }, 160);
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        goTo(currentIndex - 1);
        resetTimer();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        goTo(currentIndex + 1);
        resetTimer();
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        goTo(index);
        resetTimer();
      });
    });

    track.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize, { passive: true });

    section.addEventListener("mouseenter", stopTimer);
    section.addEventListener("mouseleave", startTimer);

    section.__wbReviewsCleanup = function () {
      stopTimer();
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      clearTimeout(resizeTimer);
      track.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      section.__wbReviewsInit = false;
    };

    updateDots();
    updateArrows();
    startTimer();
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initReviewsSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);

    if (section) initReviewsSection(section);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);

    if (section && section.__wbReviewsCleanup) {
      section.__wbReviewsCleanup();
    }
  });
})();